<template>
  <div class="font-inter h-[1040px] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />
    <div class=" h-16 my-2 px-8 bg-primaryLight space-y-6 flex items-center justify-between">
      <div class="space-y-3" >
        <h1 v-if="loading">Loading...</h1>
        <h1 v-else class="text-[20px] text-bodyText">Welcome back {{ user.first_name }},</h1>
        <p class="text-[14px] text-grayDark">Get a quick snapshot of your key metrics, recent activity, and essential updates</p>
      </div>
      <div class="relative group">
        <button
          v-if="isAdmin || isManager"
          @click="emitOpenCreateProjectModal"
          class="flex bg-primaryDarkBg hover:bg-primaryDark text-primaryLight text-[14px] font-medium px-6 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
          :disabled="goalLimit && goalLimit.is_limit_reached"
        >
          <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4">
          New Goal
        </button>
        <div v-if="goalLimit && goalLimit.is_limit_reached" class="absolute left-0 top-full mt-2 w-max bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-50">
          You have reached the maximum number of goals you can create.
        </div>
      </div>
      <!-- <div class="flex items-base space-x-4">
        <img src="@/assets/user.svg" alt="User icon" class="h-5">
        <div class="relative">
          <div class="flex items-center cursor-pointer" @click="toggleDropdown">
            <div class="font-bold text-base">{{ user.first_name }} {{ user.last_name }}</div>
            <img src="@/assets/chevron-down.svg" alt="Chevron icon" class="h-6 ml-2">
          </div>
          <div v-if="isDropdownOpen" class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg">
            <ul>
              <li class="hover:bg-gray-100 px-4 py-2 cursor-pointer" @click="logout">Logout</li>
            </ul>
          </div>
        </div>
      </div> -->
    </div>

    />
    <div v-if="!isUser">
      <TalentsComponent />
      <ProjectsComponent />
      <RecentActivity />      
    </div>
      <!-- <div  v-else class="space-y-7">
          <div class="w-[174px] h-[174px] bg-[#FBFCFC] rounded-full mx-auto mt-8 flex items-center justify-center">
          <img src="@/assets/hourglass.svg" alt="User icon" class="h-[84px]">
          </div>
          <div class="flex items-center justify-center">
          <div class="text-center w-[444px] bg-[#FFFFFF] border border-grayLight p-6 rounded-lg shadow-md">
              <div class="space-y-6">
              <p class="font-bold text-[24px] text-grayDark">Your account is pending approval</p>
              <p class="text-gray-500">
                  Thank you for signing up! Keep an eye on your inbox; your account is currently being reviewed and will be approved within 1-2 business days.
              </p>
              </div>
              <p class="text-gray-500 mt-4">
              In the meantime, feel free to explore our website. If you have any questions, please contact support@ourcompany.com.
              </p>
          </div>
          </div>
      </div> -->
      

  </div>
  <!-- <ManagerDashboard /> -->

</template>

<script>
import apiClient from '@/axios'
import NavbarComponent from '@/components/NavbarComponent.vue'
// import CreateProjectModal from '@/components/modals/CreateProjectModal.vue'
// import eventBus from '@/eventBus'
// import SkeletonLoader from '@/components/SkeletonLoader.vue'
import TalentsComponent from './dashboard/TalentsComponent.vue'
import ProjectsComponent from './dashboard/ProjectsComponent.vue'
import RecentActivity from './dashboard/RecentActivity.vue'
import eventBus from '@/eventBus';


export default {
  name: 'DashboardComponent',
  components: {
    NavbarComponent,
    // CreateProjectModal,
    // SkeletonLoader,
    TalentsComponent,
    ProjectsComponent,
    RecentActivity
    // StatusComponent,
  },
  data() {
    return {
      user: {},
      talents: [],
      projects: [],
      users: [],
      loading: true,
      showCreateProjectModal: false,
      isDropdownOpen: false,
      goalLimit: null,
    }
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isUser() {
      return this.$store.getters.isUser;
    },    
  },

  methods: {
    emitOpenCreateProjectModal() {
      eventBus.emit('openCreateProjectModal')
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    // logout() {
    //   // Call the Vuex action to perform the logout
    //   this.$store.dispatch('logout');
    //   console.log('user logged out')
    //   this.isDropdownOpen = false; // Close the dropdown after logging out
    // },

    async fetchCurrentUser() {
      try {
        const response = await apiClient.post('/current_user')
        this.user = response.data.user
        this.fetchGoalLimit(response.data.user.user_id);
      } catch (error) {
        console.error('Error fetching user data:', error)
      }
    },
    async fetchTalents() {
      try {
        const response = await apiClient.get('/web/general/talents')
        this.talents = response.data.data
      } catch (error) {
        console.error('Error fetching talents:', error)
      }
    },
    async fetchProjects() {
      try {
        const response = await apiClient.get('/web/projects_all')
        this.projects = response.data.data
      } catch (error) {
        console.error('Error fetching projects:', error)
      }
    },
    async fetchUsers() {
      try {
        if (this.isAdmin) {
        const response = await apiClient.get('web/users')
        this.users = response.data.data
        }
      } catch (error) {
        console.error('Error fetching users:', error)
      } finally {
        this.loading = false
      }
    },
    async fetchGoalLimit(userId) {
      try {
        const response = await apiClient.get('/web/limit/', {
          params: {
            id: userId,
            name: "project",
            limit_type: "user",
          },
        });
        this.goalLimit = response.data.data;
      } catch (error) {
        console.error('Error fetching goal limit:', error);
      }
    },
    goToProject(projectId) {
      this.$router.push({ name: 'ProjectDetails', params: { projectId } })
    },
  },
  // created() {
  //   this.fetchCurrentUser()
  //   this.fetchTalents()
  //   this.fetchProjects()
  //   this.fetchUsers()
  // },

  created() {
    this.fetchCurrentUser();
    this.fetchGoalLimit();
    // If role is already loaded, fetch data
    if (this.$store.getters.roleLoaded) {
      this.fetchTalents();
      // this.fetchProjects();
      this.fetchUsers();
    } else {
      // Otherwise wait for role to be loaded
      const unwatch = this.$store.watch(
        (state) => state.roleLoaded,
        (newValue) => {
          if (newValue) {
            this.fetchTalents();
            // this.fetchProjects();
            this.fetchUsers();
            unwatch(); // Remove watcher once executed
          }
        }
      );
    }
  }
}
</script>

<style scoped>
.overlap {
  margin-left: -10px;
  border-radius: 50%;
}
.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
